/*
 * One-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * SubitisingScreen.web.js - Show the questions.
 */

import PropTypes from 'prop-types';
import ButtonPad from './ButtonPad';
import Subitising from './Subitising';
import './SubitisingScreen.web.css';

export default class SubitisingScreen extends Subitising {

  constructor({ route, navigation }) {
    super(route, navigation);
  }

  render() {
    const subitiseArray = this.getSubitiseArray();
    return (
      <div id="subitising_wrapper">
        <div id="subitising_content">
          <div id="subitising_view" style={{ borderColor: this.color, borderBottomWidth: '2px', borderBottomStyle: 'solid' }}>
            {this.state.correct ? <p id="tick">✓</p> : null}
            {this.state.incorrect ? <p id="cross">✗</p> : null}
            {subitiseArray}
          </div>
          <div id="subitising_button_pad">
            <ButtonPad handleInputEvent={this.handleInputEvent} category={this.name} disabled={this.state.disabledButtons} />

          </div>
          {this.state.timeout > 0
            && (
              <div id="subitising_hint_button_view">
                <button
                  id="subitising_hint_button"
                  onClick={() => {
                    this.setSubTimer(this.state.timeout);
                  }}
                >
                  <p id="subitising_hint_button_text">Show Again</p>
                </button>
              </div>
            )}
        </div>

      </div>
    );
  }

}

SubitisingScreen.propTypes = {
  route: PropTypes.object,
  navigation: PropTypes.object
};
